export const STORE_SB_COLLAPSE = 'ui.sidebarcollapse'
export const STORE_COL_TABLES = 'ui.coldatatables'
